import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerFacingAccountPlanNavQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerFacingAccountPlanNavQuery = { __typename?: 'Query', Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, org?: { __typename?: 'Org', id: number, customerFacingAccountPlan?: { __typename?: 'CustomerFacingAccountPlan', id: string } | null } | null } } | null };


export const CustomerFacingAccountPlanNavDocument = gql`
    query CustomerFacingAccountPlanNav {
  Me {
    user {
      id
      org {
        id
        customerFacingAccountPlan {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCustomerFacingAccountPlanNavQuery__
 *
 * To run a query within a React component, call `useCustomerFacingAccountPlanNavQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerFacingAccountPlanNavQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerFacingAccountPlanNavQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerFacingAccountPlanNavQuery(baseOptions?: Apollo.QueryHookOptions<CustomerFacingAccountPlanNavQuery, CustomerFacingAccountPlanNavQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerFacingAccountPlanNavQuery, CustomerFacingAccountPlanNavQueryVariables>(CustomerFacingAccountPlanNavDocument, options);
      }
export function useCustomerFacingAccountPlanNavLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerFacingAccountPlanNavQuery, CustomerFacingAccountPlanNavQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerFacingAccountPlanNavQuery, CustomerFacingAccountPlanNavQueryVariables>(CustomerFacingAccountPlanNavDocument, options);
        }
export type CustomerFacingAccountPlanNavQueryHookResult = ReturnType<typeof useCustomerFacingAccountPlanNavQuery>;
export type CustomerFacingAccountPlanNavLazyQueryHookResult = ReturnType<typeof useCustomerFacingAccountPlanNavLazyQuery>;
export type CustomerFacingAccountPlanNavQueryResult = Apollo.QueryResult<CustomerFacingAccountPlanNavQuery, CustomerFacingAccountPlanNavQueryVariables>;